export const ACCESS = 'APP_ACCESS';
export const EXIT = 'APP_EXIT';
